import { DeleteNullish } from "./functions/deleteNullish";
import { deleteProp } from "./functions/deleteProp";
Object.deleteNullish = DeleteNullish;
Object.deleteProp = deleteProp;
//# sourceMappingURL=index.js.map